// Simple History Manager to track states with undo/redo capability
// Mirrors the Python sample API provided by the user, implemented in JavaScript

class HistoryManager {
  constructor(initialState = null) {
    this._undo_stack = [];
    this._redo_stack = [];
    this._current_state = initialState;
  }

  // Push current to undo, set new current, clear redo
  setState(newState) {
    console.log('[HistoryManager] setState() called');
    if (this._current_state !== undefined && this._current_state !== null) {
      this._undo_stack.push(this._current_state);
    }
    this._current_state = newState;
    this._redo_stack.length = 0; // clear redo
  }

  // Move current -> redo, pop from undo -> current
  undo() {
    if (this._undo_stack.length === 0) {
      console.log('[HistoryManager] Nothing to undo.');
      return this._current_state;
    }
    this._redo_stack.push(this._current_state);
    this._current_state = this._undo_stack.pop();
    return this._current_state;
  }

  // Move current -> undo, pop from redo -> current
  redo() {
    if (this._redo_stack.length === 0) {
      console.log('[HistoryManager] Nothing to redo.');
      return this._current_state;
    }
    this._undo_stack.push(this._current_state);
    this._current_state = this._redo_stack.pop();
    return this._current_state;
  }

  getState() {
    return this._current_state;
  }

  canUndo() {
    return this._undo_stack.length > 0;
  }

  canRedo() {
    return this._redo_stack.length > 0;
  }

  clear() {
    this._undo_stack.length = 0;
    this._redo_stack.length = 0;
    this._current_state = null;
  }

  get undoCount() {
    return this._undo_stack.length;
  }

  get redoCount() {
    return this._redo_stack.length;
  }
}

export default HistoryManager;
